import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/service/service.vue'
wx.createPage(MiniProgramPage)